import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import FooterMini from '../components/FooterMini';
import { Button } from '../components/ui/button';
import { useAuth } from '../auth/AuthContext';
import { useI18n } from '../i18n';
import Seo from '../seo/Seo';

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get('next') || '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await login(email, password);
      nav(next, { replace: true });
    } catch (e) {
      setErr(e.message || 'Falha ao entrar');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Seo titleKey="seoLoginTitle" path="/login" noindex />
      <Header />
      <main className="flex-1 grid place-items-center px-3 sm:px-5 py-8 sm:py-10 blueprint-grid">
        <div className="w-full max-w-md bg-white rounded-xl border border-zinc-200 shadow-sm p-7">
          <h1 className="font-chunky text-2xl text-zinc-950 mb-1">{t('signIn') || 'Entrar'}</h1>
          <p className="text-zinc-500 text-sm mb-6">{t('signInSub') || 'Acesse sua conta MakerCut.'}</p>
          <form onSubmit={submit} className="space-y-3">
            <Field label="E-mail">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     className="w-full px-3 py-2 rounded-md border border-zinc-200 outline-none focus:border-cyan-500 font-mono text-sm" />
            </Field>
            <Field label="Senha">
              <input type="password" required minLength={1} value={password} onChange={(e) => setPassword(e.target.value)}
                     className="w-full px-3 py-2 rounded-md border border-zinc-200 outline-none focus:border-cyan-500 font-mono text-sm" />
            </Field>
            {err && <div className="text-rose-700 bg-rose-50 border border-rose-200 rounded p-2 text-xs">{err}</div>}
            <Button disabled={busy} type="submit"
                    className="w-full bg-zinc-950 hover:bg-zinc-800 text-cyan-300 font-chunky uppercase tracking-wider">
              {busy ? '...' : 'Entrar'}
            </Button>
          </form>
          <div className="flex justify-between mt-4 text-[12px] text-zinc-500">
            <Link to="/forgot" className="hover:text-cyan-700">Esqueci minha senha</Link>
            <Link to="/signup" className="hover:text-cyan-700">Criar conta</Link>
          </div>
        </div>
      </main>
      <FooterMini />
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="font-chunky uppercase tracking-wider text-[10px] text-zinc-600 mb-1">{label}</div>
      {children}
    </label>
  );
}
